import { render, staticRenderFns } from "./SurveyCommentList.vue?vue&type=template&id=20201bbc&scoped=true&"
import script from "./SurveyCommentList.vue?vue&type=script&lang=ts&"
export * from "./SurveyCommentList.vue?vue&type=script&lang=ts&"
import style0 from "./SurveyCommentList.vue?vue&type=style&index=0&id=20201bbc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20201bbc",
  null
  
)

export default component.exports